import React from "react";
import { IdcardOutlined, ClusterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ProductLockPage from "components/ProductLock/ProductLockPage";
import lockStyles from "components/ProductLock/style.module.scss";

const Customer365LockPage = ({ theme }) => {
  const { t } = useTranslation();
  return (
    <ProductLockPage productKey="customer_365" theme={theme}>
      <div className={lockStyles.lockCardGhostOne}>
        <IdcardOutlined />
        <span>{t("customer_365_lock.ghost_profile")}</span>
        <strong>{t("customer_365_lock.ghost_unified")}</strong>
      </div>
      <div className={lockStyles.lockCardGhostTwo}>
        <ClusterOutlined />
        <span>{t("customer_365_lock.ghost_sources")}</span>
        <strong>{t("customer_365_lock.ghost_audience")}</strong>
      </div>
    </ProductLockPage>
  );
};

export default Customer365LockPage;
